import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-other-item-presentation-card',
  templateUrl: './other-item-presentation-card.component.html',
  styleUrls: ['./other-item-presentation-card.component.scss']
})
export class OtherItemPresentationCardComponent implements OnInit {
  @Input() item: any;
  constructor() { }

  ngOnInit(): void {
  }

}
